// Hero met een gewone video (30-9-2026). Doet drie dingen, en niet meer:
//  1. de tekst laat schalen met de breedte (op 1920 breed is hij zo groot als in de pagina staat), zoals km-hero.js dat deed;
//  2. de tekst laten binnenkomen zoals bij het script: klasse km-in bij elke ronde en op de tijden in data-tekst-opnieuw (seconden),
//     klasse km-uit vlak voor het eind (data-tekst-uit seconden) en vlak voor elke nieuwe entree. De pagina bepaalt hoe dat eruitziet;
//  3. de video stilzetten als hij niet in beeld is (batterij), en helemaal niet laten lopen bij "minder beweging".
// Lukt afspelen niet (zuinige stand van een telefoon), dan blijft het beeld staan en staat de tekst er gewoon.
(function () {
  function start(el) {
    if (el._kmhv) return; el._kmhv = true;
    const v = el.querySelector('video'), blok = el.querySelector('[data-km-tekst]');
    if (!v || !blok) return;
    const opnieuw = (el.dataset.tekstOpnieuw || '').split(/[ ,]+/).map(Number).filter(n => n > 1);
    const uitVoor = el.dataset.tekstUit !== undefined && el.dataset.tekstUit !== '' ? +el.dataset.tekstUit : 3;
    const pas = () => el.style.setProperty('--km-k', (el.clientWidth / 1920).toFixed(4));
    new ResizeObserver(pas).observe(el); pas();
    if (matchMedia('(prefers-reduced-motion: reduce)').matches) { v.removeAttribute('autoplay'); v.pause(); return; }
    const binnen = () => { blok.classList.remove('km-in', 'km-uit'); void blok.offsetWidth; blok.classList.add('km-in'); };
    let vorig = -1, uitNu = null;
    const tik = () => {
      const t = v.currentTime, T = v.duration || 0;
      if (vorig < 0 || t < vorig - 0.5) { binnen(); uitNu = false; }
      for (const o of opnieuw) if (vorig >= 0 && vorig < o && t >= o && t < o + 1) { binnen(); uitNu = false; }
      const uit = (T > 0 && t >= T - uitVoor) || opnieuw.some(o => t >= o - 0.8 && t < o);
      if (uit !== uitNu) { blok.classList.toggle('km-uit', uit); if (uit) blok.classList.remove('km-in'); uitNu = uit; }
      vorig = t;
    };
    v.addEventListener('timeupdate', tik);
    v.addEventListener('seeked', () => { vorig = -1; tik(); });
    if ('IntersectionObserver' in window) new IntersectionObserver(es => {
      for (const e of es) { if (e.isIntersecting) { const p = v.play(); if (p && p.catch) p.catch(() => {}); } else v.pause(); }
    }, { threshold: 0.1 }).observe(el);
  }
  const zoek = () => document.querySelectorAll('[data-km-hero-video]').forEach(start);
  document.addEventListener('DOMContentLoaded', zoek); zoek();
  document.addEventListener('shopify:section:load', zoek);
})();
